import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function Table({ children, caption, className = "", ...rest }) {
    return (_jsx("div", { className: "nbs-table-wrap", children: _jsxs("table", { className: `nbs-table ${className}`.trim(), ...rest, children: [caption ? (_jsx("caption", { className: "nbs-text nbs-text--sm nbs-text--muted", children: caption })) : null, children] }) }));
}
export function TableHead({ children, ...rest }) {
    return _jsx("thead", { ...rest, children: children });
}
export function TableBody({ children, ...rest }) {
    return _jsx("tbody", { ...rest, children: children });
}
export function TableRow({ children, ...rest }) {
    return _jsx("tr", { ...rest, children: children });
}
export function TableHeaderCell({ children, ...rest }) {
    return (_jsx("th", { scope: "col", ...rest, children: children }));
}
export function TableCell({ children, ...rest }) {
    return _jsx("td", { ...rest, children: children });
}
//# sourceMappingURL=Table.js.map